import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {
  transform(value: Date | string): string {
    if(!value) return '';
    
    const date = new Date(value);
    const today = new Date();
    
    if (date.toDateString() === today.toDateString()) {
      return new DatePipe('en-US').transform(date, 'HH:mm');
    }
    return new DatePipe('en-US').transform(date, 'd/M HH:mm');
  }
}